"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AssignmentPlanPlayer", {
  enumerable: true,
  get: function get() {
    return _AssignmentPlanPlayer["default"];
  }
});
Object.defineProperty(exports, "BackgroundLayout", {
  enumerable: true,
  get: function get() {
    return _BackgroundLayout["default"];
  }
});
Object.defineProperty(exports, "Certificate", {
  enumerable: true,
  get: function get() {
    return _Certificate["default"];
  }
});
Object.defineProperty(exports, "DataBrowser", {
  enumerable: true,
  get: function get() {
    return _DataBrowser["default"];
  }
});
Object.defineProperty(exports, "DeploymentEvaluator", {
  enumerable: true,
  get: function get() {
    return _DeploymentEvaluator["default"];
  }
});
Object.defineProperty(exports, "DeploymentPlayer", {
  enumerable: true,
  get: function get() {
    return _DeploymentPlayer["default"];
  }
});
Object.defineProperty(exports, "EndpointEvaluator", {
  enumerable: true,
  get: function get() {
    return _EndpointEvaluator["default"];
  }
});
Object.defineProperty(exports, "Export", {
  enumerable: true,
  get: function get() {
    return _ExportExport["default"];
  }
});
Object.defineProperty(exports, "ExportedFlags", {
  enumerable: true,
  get: function get() {
    return _ExportedFlags["default"];
  }
});
Object.defineProperty(exports, "MessageViewer", {
  enumerable: true,
  get: function get() {
    return _MessageViewer["default"];
  }
});
Object.defineProperty(exports, "Messaging", {
  enumerable: true,
  get: function get() {
    return _ExportMessaging["default"];
  }
});
Object.defineProperty(exports, "OutcomesDataEntry", {
  enumerable: true,
  get: function get() {
    return _OutcomesData["default"];
  }
});
Object.defineProperty(exports, "Progress", {
  enumerable: true,
  get: function get() {
    return _ExportStatus["default"];
  }
});
Object.defineProperty(exports, "ProgressBar", {
  enumerable: true,
  get: function get() {
    return _ProgressBar["default"];
  }
});
Object.defineProperty(exports, "Quest", {
  enumerable: true,
  get: function get() {
    return _Root["default"];
  }
});
Object.defineProperty(exports, "SessionDataEntry", {
  enumerable: true,
  get: function get() {
    return _SessionData["default"];
  }
});
Object.defineProperty(exports, "ViewData", {
  enumerable: true,
  get: function get() {
    return _ExportData["default"];
  }
});
Object.defineProperty(exports, "generateAssignmentPreviewLink", {
  enumerable: true,
  get: function get() {
    return _generateAssignmentPreviewLink["default"];
  }
});
var _Root = _interopRequireDefault(require("./Root.js"));
var _AssignmentPlanPlayer = _interopRequireDefault(require("./components/AssignmentPlanPlayer"));
var _BackgroundLayout = _interopRequireDefault(require("./components/BackgroundLayout"));
var _Certificate = _interopRequireDefault(require("./components/navigations/courseWrapper/Mediator/Certificate"));
var _DeploymentEvaluator = _interopRequireDefault(require("./components/DeploymentEvaluator"));
var _DeploymentPlayer = _interopRequireDefault(require("./components/DeploymentPlayer"));
var _EndpointEvaluator = _interopRequireDefault(require("./components/EndpointEvaluator"));
var _SessionData = _interopRequireDefault(require("./components/DataEntry/SessionData"));
var _OutcomesData = _interopRequireDefault(require("./components/DataEntry/OutcomesData"));
var _ExportStatus = _interopRequireDefault(require("./pages/Status/ExportStatus"));
var _ExportData = _interopRequireDefault(require("./pages/Data/ExportData"));
var _ExportExport = _interopRequireDefault(require("./pages/Export/ExportExport"));
var _ExportMessaging = _interopRequireDefault(require("./pages/Messaging/ExportMessaging"));
var _MessageViewer = _interopRequireDefault(require("./pages/Messaging/MessageViewer"));
var _ProgressBar = _interopRequireDefault(require("./components/ProgressBar"));
var _generateAssignmentPreviewLink = _interopRequireDefault(require("./helpers/generateAssignmentPreviewLink.js"));
var _DataBrowser = _interopRequireDefault(require("./components/DataBrowser"));
var _ExportedFlags = _interopRequireDefault(require("./components/ExportedFlags"));
var _reducer = _interopRequireDefault(require("./reducer.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Inject assignment reducer
var store = window.cccisd && window.cccisd.store;
if (store) {
  if (!store.getState().assignment) {
    store.injectReducer('assignment', _reducer["default"]);
  }
} else if (process.env.NODE_ENV !== 'test') {
  console.error('There is no redux store at window.cccisd');
}